module.exports = __webpack_public_path__ + "img/question-mark-small.17474f8.svg";